import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {takeUntil} from "rxjs/operators";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {QueryProvider} from "@shared/queries/query-provider";
import {Subject} from "rxjs";
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";
import {ButtonEditorModel} from "@shared/components/multiple-button-editor/multiple-button-editor.component";
import {DownloadType} from "../../Fields";

@Component({
    standalone: false,
    selector: 'particle-filing-export-options-dialog',
  templateUrl: './filing-export-options-dialog.component.html',
  styleUrls: ['./filing-export-options-dialog.component.scss']
})
export class FilingExportOptionsDialogComponent implements IDialogView, OnInit, OnDestroy {
  data: DialogModel;
  selectedExportOptions: any;
  unSubscribe$ = new Subject<void>();
  exportButtonList: ButtonEditorModel[] = [];
  filingExportOptions: any;
  dropDownOptions: any;
  hasSingleCase = false;
  hasMergedItem
    = false;
  XmlMergeCountrySupport: string;
  //singleCaseButtonDescription = "Download your DAC6 Form(s) to your computer. Multiple DAC6 Forms will be combined into a single ZIP file (right-click the ZIP file and select 'Extract All...' to retrieve the individual files).";
  constructor(private queryStore: Store<IQueryState>) { }

  ngOnInit() {
    this.filingExportOptions = this.getFilingExportOptions(this.data.input['options']);
    if(this.filingExportOptions.XmlMergeCountrySupport){
      this.XmlMergeCountrySupport = this.filingExportOptions.XmlMergeCountrySupport.join(', ');
    }
    if(this.data.input['selectedItemCount'] === 1 || !this.data.input['selectedItemCount'] ){
      this.hasSingleCase = true;
    }

    this.selectedExportOptions = this.getExportDownloadOption();

    this.dropDownOptions = this.filingExportOptions.ExportOptions;//.filter(option=>option.HasImplementation);
    this.exportButtonList = [
      this.getSetSelectedDownloadButton(),
      this.getDriveButtonDetails(this.data.input['scenarioType']),
    ];
    this.data.input['ExportOption'] = this.selectedExportOptions;
    /*this.queryStore.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, 'GetFilingOptionsConfig')).subscribe(options=>{
      if(options){
        this.filingExportOptions = options;
        this.selectedExportOptions = options.ExportOptions.find(option=>option.DownloadType === options.DefaultDownloadType);
        this.exportButtonList = [
          this.getSetSelectedDownloadButton(),
          {
            id: `SaveToDrive-${this.selectedExportOptions.DownloadType}`,
            title: 'Save Form(s) to my Document Repository',
            description: 'Save form(s) as individual XML files to a Drive in your  Orbitax Document Repository where you can download and share with other users',
            buttonTitle: 'Save To Drive',
            imageSource: './../../../assets/images/orbitax-images/select.png',
            isDisabled: false
          }
        ];
      }
    });
    QueryProvider.invokeQuery(this.queryStore, 'GetFilingOptionsConfig', {'[CODE]': this.data.input['countryCode']});*/
  }

  onOkClicked(): boolean {
    return true;
  }
  onExport(event){
    this.data.input['clickAction'].emit(event);
  }
  onSelectionChange(event){
    this.selectedExportOptions = event.value;
    this.data.input['ExportOption'] = this.selectedExportOptions;
    this.hasMergedItem = event.value.IsMerge;
    this.exportButtonList[0]=this.getSetSelectedDownloadButton();
    let downloadType = this.selectedExportOptions.DownloadType;
    if(!this.hasSingleCase && this.selectedExportOptions.Type !== 'XML'){
      downloadType = 'ZIP';
    }
    this.exportButtonList[1].id = `SaveToDrive-${downloadType}`;
    this.exportButtonList[1].buttonTitle = `Save (.${downloadType})`;
  }
  getSetSelectedDownloadButton(){
    return {
      id: this.selectedExportOptions.DownloadType,
      title: 'Download Form(s)',
      description: this.selectedExportOptions.MetaData['Description'],
      buttonTitle: this.selectedExportOptions.MetaData['ButtonTitle'],
      imageSource: this.selectedExportOptions.MetaData['ImageSource'],
      isDisabled: false
    }
  }
  ngOnDestroy(): void {
  }
  getDriveButtonDetails(scenarioType = null){
    const buttonDetails = this.getGenericButtonDetails(scenarioType);
    const currentDownloadType = this.selectedExportOptions.DownloadType;
    buttonDetails.id = buttonDetails.id.replace('[TYPE]',currentDownloadType);
    buttonDetails.description = buttonDetails.description.replace('[TYPE]',currentDownloadType);
    buttonDetails.buttonTitle = buttonDetails.buttonTitle.replace('[TYPE]',currentDownloadType);
    return buttonDetails;
  }
  getGenericButtonDetails(scenarioType = null): ButtonEditorModel{
    let des = 'Save your DAC6 Form(s) to your Orbitax Document Repository where you can choose to download at any time, add comments, check out for adjustments or share with your list of Contacts.'
    // temporarily added for GMT Forms
    if (scenarioType == 'GMT') {
      des = 'Save your GMT Form(s) to your Orbitax Document Repository where you can choose to download at any time, add comments, check out for adjustments or share with your list of Contacts.'
    }
    if(this.hasSingleCase){
      return {
        id: `SaveToDrive-[TYPE]`,
        title: 'Save Form(s) to Drive',
        description: des,
        buttonTitle: 'Save (.[TYPE])',
        imageSource: 'https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/save-to-my-repo.png',
        isDisabled: false
      }
    }
    else{
      return {
        id: `SaveToDrive-[TYPE]`,
        title: 'Save Form(s) Drive',
        description: des,
        buttonTitle: 'Save (.[TYPE])',
        imageSource: 'https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/save-to-my-repo.png',
        isDisabled: false
      }
    }
  }

  private getFilingExportOptions(exportOptions: any) {
    let clonedItems = JSON.parse(JSON.stringify(exportOptions));
    if(this.data.input['selectedItemCount'] > 1){
      clonedItems.ExportOptions = clonedItems.ExportOptions.filter(item=>item.MetaData['IsMultipleCase']);
      clonedItems.ExportOptions.forEach(item=>{
        if(item.IsMerge){
          this.hasMergedItem = true;
          item.MetaData['Title'] = item.MetaData['Title'].replace('Type', `Merged ${item.DownloadType}`);
        }else{
          item.MetaData['Title'] = item.MetaData['Title'].replace('Type', `${item.DownloadType}`);
        }
      });
      clonedItems.ExportOptions.forEach(item=>{
        if(item.DownloadType !== DownloadType.XML && item.DownloadType !== DownloadType.fvie){
          item.MetaData['ButtonTitle'] = 'Download (.ZIP)';
        }
      });
    }else{
      clonedItems.ExportOptions.forEach(item=>{
        item.MetaData['Title'] = item.MetaData['Title'].replace('Type', `${item.DownloadType}`);
      });
      clonedItems.ExportOptions = clonedItems.ExportOptions.filter(item=>item.MetaData['IsSingleCase']);
    }

    return clonedItems;
  }

  private getExportDownloadOption() {
    let downloadType = this.filingExportOptions.DefaultDownloadType;
    let selectedExportOption;
    if(this.data.input['selectedItemCount'] > 1){
      let hasMergedItems = false;
      this.filingExportOptions.ExportOptions.forEach(item=>{
        if(item.IsMerge){
          hasMergedItems = true;
        }
      });
      if( hasMergedItems ) downloadType = DownloadType.XML;
      else if( downloadType !== DownloadType.fvie ) downloadType = DownloadType.ZIP;
    }
    else {
      if ( downloadType === DownloadType.ZIP ) downloadType = DownloadType.XML;
    }
    selectedExportOption = this.filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    if(!selectedExportOption){
      downloadType = this.filingExportOptions.DefaultDownloadType;
      selectedExportOption = this.filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    }
    return selectedExportOption;
  }
}
